/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import Close from '@material-ui/icons/Close';
import Callout from '$components/Callout';
import parseCsv from './utils/parseCsv';
import getFileError from './utils/getFileError';

import {
  Dropzone,
  DropzoneIcon,
  DropText,
  DropTextSmall,
  FakeLink,
  TickIcon,
  RemoveButton,
  ErrorIcon,
  Instructions,
} from './Step1.styled';

const Step1 = ({
  file,
  fileError,
  onFileDropComplete,
  hasGrades,
  hasGradesReleased,
}) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: '.csv',
    multiple: false,
    onDrop: async ([acceptedFile], fileRejections) => {
      const parsed = await parseCsv(acceptedFile);
      const error = await getFileError({
        accepted: parsed,
        rejections: fileRejections,
      });

      onFileDropComplete({
        droppedFile:
          parsed && !error ? { name: acceptedFile.name, ...parsed } : null,
        error,
      });
    },
  });

  const handleRemoveFile = (e) => {
    e.stopPropagation();
    onFileDropComplete({ droppedFile: null, error: null });
  };

  return (
    <>
      {hasGradesReleased && (
        <Callout>
          The grades for this assignment are already released, so every change
          will be immediately visible to students.
        </Callout>
      )}
      <Instructions>
        You can upload a CSV file whose columns include student emails and
        grades.
        {hasGrades && (
          <strong>This will override the grades you previously entered.</strong>
        )}
      </Instructions>
      <Dropzone
        {...getRootProps({
          isDragActive,
          hasFile: !!file,
          hasError: !!fileError,
          'data-testid': 'dropzone',
        })}
      >
        <input {...getInputProps()} />
        {fileError && (
          <>
            <ErrorIcon />
            <div>Upload failed: {fileError}</div>
            <DropTextSmall>
              Drag and drop or <FakeLink>select file</FakeLink> to upload
            </DropTextSmall>
          </>
        )}
        {!fileError && file && (
          <>
            <RemoveButton aria-label="Remove file" onClick={handleRemoveFile}>
              <Close />
            </RemoveButton>
            <TickIcon />
            <div>{file.name}</div>
          </>
        )}
        {!fileError && !file && (
          <>
            <DropzoneIcon isDragActive={isDragActive} />
            <DropText>
              Drag and drop or <FakeLink>select file</FakeLink>
            </DropText>
          </>
        )}
      </Dropzone>
    </>
  );
};

Step1.propTypes = {
  file: PropTypes.shape({
    name: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
    errors: PropTypes.array.isRequired,
  }),
  onFileDropComplete: PropTypes.func.isRequired,
  fileError: PropTypes.string,
  hasGrades: PropTypes.bool,
  hasGradesReleased: PropTypes.bool,
};

Step1.defaultProps = {
  file: undefined,
  fileError: undefined,
  hasGrades: false,
  hasGradesReleased: false,
};

export default Step1;
